var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"i_maxW"},[_c('div',{staticClass:"i_copyright"},[_vm._v(_vm._s(_vm.copyRight))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }